import React from 'react';
import { GridSquareCard } from './GridSquareCard';
import type { UserKind } from '@/components/ui/UserTypeIcon';

export interface SpecialAuctionCardProps {
    displayName: string;
    username: string;
    avatarUrl?: string;
    price?: string | number;
    bg?: string;
    textColor?: string;
    grainOpacity?: number;
    scale?: number;
    compact?: boolean;
    initialSeconds?: number;
    isPending?: boolean;
    hasBids?: boolean;
    bidsCount?: number;
    userKind?: UserKind;
    onClick?: () => void;
}

export const SpecialAuctionCard: React.FC<SpecialAuctionCardProps> = (props) => {
    return <GridSquareCard {...props} isAuction={true} />;
};

export default SpecialAuctionCard;
